import { atom } from 'jotai';

// Atom to control the PicStudioDriveDialog open state
export const picstudioDriveDialogOpenAtom = atom<boolean>(false);

// Optional: Atom for storing return URL if needed
export const picstudioDriveDialogReturnUrlAtom = atom<string>('/dashboard'); 